function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

//
docReady(() => {
//

    const headerWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    const headerLinks = document.getElementsByClassName('header-list-item');
    // console.log(screen.width)

    const selectedProducts = JSON.parse(window.localStorage.getItem('selectedProducts'));
    let selectedProductsAmount = '';
    if (selectedProducts) {
        selectedProductsAmount = selectedProducts.filter(Boolean).length;
    }


    if (selectedProductsAmount > 0) {
        const badge = document.getElementById('badge');
        badge.innerHTML = selectedProductsAmount;
        badge.classList.remove('hidden');
        badge.classList.add('flex');
    }

    if (headerWidth < 641) {
        for (let link of headerLinks) {

            link.addEventListener('click', (e) => {
                console.log('clicked')

                const subMenu = document.getElementById(link.dataset.slug);
                if (subMenu.classList.contains('hidden')) {
                    e.preventDefault();
                    subMenu.classList.toggle('hidden');
                }
                // if (e.currentTarget.dataset.slug === 'termekeink' || e.currentTarget.dataset.slug === 'szolgaltatasok') {
                //         console.log('target', e.target);
                //         console.log('current target', e.currentTarget)
                // }
            });
        }
    }
});
